import { tracking } from '../tracking.service'

export function useAnalytics() {
  return tracking
}
